<template>
  <div class="Actor">
    <v-container grid-list-md fluid fill-height>
      <v-layout
        justify-center
        align-center
      >
        <v-flex md8>
          <v-card class="mb-2">
            <v-card-title class="title">
              Reporte por Actor
            </v-card-title>

            <v-card-text
              v-if="loading"
              class="text-xs-center"
            >
              <v-progress-circular
                :size="progressSize"
                :width="progressWidth"
                color="info"
                indeterminate
              ></v-progress-circular>
            </v-card-text>

            <v-card-text v-else>
              <chart-column
                :chartOptions="chartOptions"
                :chartSeries="chartSeries"
                :key="chartKey"
              />
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import chartColumn from '@/components/Charts/ColumnBase'

export default {
  name: 'Actor',

  components: {
    'chart-column': chartColumn
  },

  /**
   * Esta función carga el respectivo Layout, al crear la vista.
   */
  created () {
    this.$store.commit('SET_LAYOUT', 'dashboard-layout')
    this.loadData()
  },

  data: function () {
    return {
      backConf: {
        path: '/semcali/rp_actor',
        page: 1
      },

      loading: false,
      progressSize: 70,
      progressWidth: 7,
      chartKey: 0,

      colors: ['#008FFB', '#00E396', '#FEB019', '#FF4560', '#775DD0', '#546E7A', '#26a69a', '#D10CE8'],

      chartSeries: null,
      chartOptions: {
        chart: {
          height: 350,
          toolbar: {
            show: true
          },
          zoom: {
            enabled: true
          }
        },
        // colors: ['#008FFB', '#00E396', '#FEB019', '#FF4560', '#775DD0', '#546E7A', '#26a69a', '#D10CE8'],
        responsive: [
          {
            breakpoint: 480,
            options: {
              legend: {
                position: 'bottom',
                offsetX: -10,
                offsetY: 0
              }
            }
          }
        ],
        plotOptions: {
          bar: {
            dataLabels: {
              position: 'top' // top, center, bottom
            }
          }
        },
        dataLabels: {
          enabled: true,
          formatter: function (val) {
            return val
          },
          offsetY: -20,
          style: {
            fontSize: '12px',
            colors: ['#304758']
          }
        },

        xaxis: {
          categories: [
            'Actores W', 'Administrativo', 'Aliado PPP', 'Comunidad participante',
            'Directivo', 'Docente', 'Docente tutor', 'Estudiante', 'Familia',
            'Formador deportivo', 'Lider Cultural/Tallerista', 'Ludotecario'
          ],
          title: {
            text: 'Tipo de Actor'
          }
        },
        yaxis: {
          title: {
            text: 'Número de Encuestas'
          }
        },
        legend: {
          position: 'right',
          offsetY: 40
        },
        fill: {
          opacity: 1
        }
      }
    }
  },

  methods: {
    /**
     * Carga los datos de las encuestas
     */
    loadData () {
      this.loading = true
      let request = {
        method: 'get',
        data: {},
        url: this.backConf.path
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.chartSeries = resp.data
          t.loading = false
          t.chartKey += 1
        })
        .catch(err => console.error(err))
    }
  }
}
</script>
